import { render } from "./ddyexplain.vue?vue&type=template&id=6b9e32d6&scoped=true"
const script = {}

import "./ddyexplain.vue?vue&type=style&index=0&id=6b9e32d6&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9e32d6"]])

export default __exports__